<template>
  <div class="base_color">
    <div id="container">

      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause">
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          浦发银行
        </p>
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          个人信息查询和提供在线授权书
        </p>
        <p class="distance_50">
          上海浦东发展银行股份有限公司：
        </p>
        <p class="distance_50">
          本人 （“授权人”）在此不可撤销地授权贵行（“被授权人”）根据本
          授权书查询和提供授权人的信息。
        </p>
        <p class="distance_50">
          ★一、授权事项
        </p>
        <p class="distance_50">
          1、授权人个人信息的查询和使用
        </p>
        <p class="distance_50">
          授权人在办理本业务时，被授权人依法可以通过如下途径获取您的 以下信息：
        </p>
        <p class="distance_50">
          向中国人民银行金融信用信息基础数据库及其他经中国人民银行
          批准设立的征信机构查询授权人的全部信用信息及信用报告。
        </p>
        <p class="distance_50">
          向资信评估机构、风险管理专业机构或有关法律、监管机构许可的
          类似数据机构查询、核实、打印、留存您的信息和（或）信用报告。
        </p>
        <p class="distance_50">
          向政府机关、事业单位、司法机关、监管部门、中国互联网金融协
          会等行业自律组织查询、打印、留存任何与本业务相关信息。
        </p>
        <p class="distance_50">
          2、授权信息范围：
        </p>
        <p class="distance_50">
          授权人同意被授权人收集的信息包括但不限于：
        </p>
        <p class="distance_50">
          授权人的姓名/名称、证件类型及号码、户籍所在地、住所地、经
          常居住地、电话号码、在被授权人处开立的账户认证信息、人脸识别所
          需生物特征以及其他身份信息。
        </p>
        <p class="distance_50">
          授权人在申请、办理本业务时，访问本行服务网站或业务移动设备
          客户端时的操作日志、包括但不限于授权人的计算机 IP 地址、设备标
          识符、硬件型号、操作系统版本、授权人位置信息等。
        </p>
        <p class="distance_50">
          授权人在申请、办理本业务时所提供、形成的任何数据和信息，包
          括但不限于授权人提供的关联数据信息。
        </p>
        <p class="distance_50">
          授权人的财产信息，包括但不限于授权人的财税信息、房产信息、
          车辆信息、基金、保险、股票、信托、债券等投资理财信息和负债信息 等。
        </p>
        <p class="distance_50">
          授权人在各机构留存的任何信息，包括但不限于授权人作为法定代
          表人或负债人或经营者或股东的工商信息、诉讼信息、执行信息和违法
          犯罪信息等。
        </p>
        <p class="distance_50">
          授权人在此同意并确认，授权人在前述信息提供给被授权人之前，
          已清楚知晓可能带来的不利后果，包括但不限于基于前述信息对授权人
          作出的负面评价。
        </p>
        <p class="distance_50">
          3、授权人信息的对外提供
        </p>
        <p class="distance_50">
          根据征信相关法律法规和监管规定的要求，被授权人有权将在双方
          相关授信业务关系建立和存续期间获得的与本授权人有关的信息，包括
          信贷信息、信用信息、个人基本信息、不良信息和其他信息资料，提供
          给金融信用信息基础数据库及其他经中国人民银行批准设立的征信机
          构的数据库。
        </p>
        <p class="distance_50">
          ★二、信息使用
        </p>
        <p class="distance_50">
          授权信息用于审核本人授信和贷款申请，以及对已发放的个人信贷
          进行贷后管理；基于本人/本单位资格审查、授信方案制定、信贷资产
          质量监控、债务追索、担保方案制定、担保资产质量监控、担保责任追
          索、关联关系查询及其他为确保实现被授权人在相关授信业务合同下利
          益之目的，被授权人有权查询、使用和保存前述信用信息及信用报告。
        </p>
        <p class="distance_50">
          ★三、授权期限
        </p>
        <p class="distance_50">
          授权期限自本授权书载明的签署日期起至授信意向下发生的业务
          （如有）完全履行完毕之日止。如被授权人经审核拒绝接受本授权人的
          申请，则授权期限至被授权人正式通知本授权人之日止。
        </p>
        <p class="distance_50">
          三、其他
        </p>
        <p class="distance_50">
          如被授权人超出本授权书的范围违法查询和使用本授权人的信用
          信息，被授权人应承担相应的法律责任。
        </p>
        <p class="distance">
          本授权人知悉和完全理解本授权书的内容，尤其是标记★的条款，
          本授权书下的授权是本授权人自愿作出的真实意思表示，并愿意承担相
          应的法律责任。经本授权人通过在线确认同意即视为签署本授权书并生 效。
        </p>
        <p class="distance_50">
          授权人：
        </p>
        <p class="distance_50">
          身份证件类型：中华人民共和国居民身份证
        </p>
        <p class="distance_50">
          证件号码：______________
        </p>
        <p class="distance_50">
          授权日期：_________
        </p>
        <p class="distance_50">
          ____年
        </p>
        <p class="distance_50">
          ____月
        </p>
        <p class="distance_50">
          ____日
        </p>
        <br/>
        <br/>
         <p style=" font-weight: bold; font-size: 16px;text-align:center">
          用途声明书
        </p>
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          上海浦东发展银行：
        </p>
        <p class="distance_50">
          本人在此承诺，本人向贵行申请的本笔贷款用于以本人为法定代 表人/负责人/实际控制人的经营。
        </p>
        <p class="distance_50">
          本人承诺决不会将贷款资金挪用于购买住房、投入商业房地产开 发、证券、期货、股本权益性投资等国家法律和金融法规明令禁止的 领域。
        </p>
        <p class="distance_50">
         浦发银行有权不定期核实本人所申请贷款资金使用情况，如经发 现贷款挪作他用，浦发银行有权提前收回贷款。特此声明。
        </p>
        <p class="distance_50">
          借款人姓名：
        </p>
        <p class="distance_50">
         证件号码：________
        </p>
        <p class="distance_50">
          日期：____ 年 ____ 月 _____ 日
        </p>
        <div ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 6px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
